import { render, staticRenderFns } from "./myRecord.vue?vue&type=template&id=22e1265a&scoped=true&"
import script from "./myRecord.vue?vue&type=script&lang=js&"
export * from "./myRecord.vue?vue&type=script&lang=js&"
import style0 from "./myRecord.vue?vue&type=style&index=0&id=22e1265a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1265a",
  null
  
)

export default component.exports